<template>
  <SocialMarketingCardContainer :style="brandBG" :inProgress="inProgress">
    <div class="card-p-3 flex-1 justify-content-between d-flex flex-column">
      <SocialMarketingStudioInfo
        class="card-mb-3"
        :color="cardColorType"
        :studioUrl="studioUrl"
      />
      <SocialMarketingStudioContent
        :title="marketingAsset.title"
        :description="marketingAsset.description"
        :descriptionMaxLines="6"
        :colorType="cardColorType"
      />
    </div>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';
import { isBrightColor } from '@/web/utils/colors.js';

export default {
  name: 'Template1',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
  },
  computed: {
    cardColorType() {
      return isBrightColor(this.marketingAsset?.primary_color)
        ? 'dark-opacity'
        : 'light';
    },
    brandBG() {
      return {
        backgroundColor: this.marketingAsset?.primary_color,
      };
    },
    marketingAsset() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
